import { useEffect, useState } from "react";
import { api } from "../api";
import { Pill } from "../components/Pill";

const TOOLS = [
  { key: "chatgpt", label: "ChatGPT" },
  { key: "claude", label: "Claude" },
  { key: "gemini", label: "Gemini" },
  { key: "copilot", label: "Copilot" },
];

const MODES = [
  { key: "allowed", label: "Allowed" },
  { key: "allowed_warn", label: "Allowed · With Warnings" },
  { key: "allowed_strict", label: "Strict" },
  { key: "blocked", label: "Blocked" },
];

export function DomainsPage() {
  const [domains, setDomains] = useState<any[]>([]);
  const [busy, setBusy] = useState(false);

  async function load() {
    const res = await api.getPolicyBundle();
    setDomains(res.domains);
  }
  useEffect(() => { load(); }, []);

  async function update(domainKey: string, patch: any) {
    setBusy(true);
    try {
      await api.updateDomainConfig({ domainKey, ...patch });
      await load();
    } finally { setBusy(false); }
  }

  return (
    <>
      <header className="sg-page-header">
        <div>
          <h1 className="sg-page-title">Domains</h1>
          <div className="sg-page-sub">Per-Tool Access · Strictness</div>
        </div>
      </header>

      <div className="sg-grid sg-grid-3">
        {TOOLS.map((t) => {
          const cfg = domains.find((d) => d.domainKey === t.key) ?? { domainKey: t.key, enabled: true, defaultActionMode: "allowed", strictness: 1 };
          return (
            <div key={t.key} className="sg-panel">
              <div className="sg-panel-head">
                <div className="sg-panel-title">{t.label}</div>
                <Pill kind={cfg.defaultActionMode === "blocked" ? "block" : cfg.defaultActionMode === "allowed_strict" ? "rewrite" : cfg.defaultActionMode === "allowed_warn" ? "warn" : "allow"}>
                  {cfg.defaultActionMode.replace("_", " ")}
                </Pill>
              </div>
              <div className="sg-panel-pad">
                <div className="sg-field">
                  <label className="sg-label">Access Mode</label>
                  <select
                    className="sg-select"
                    value={cfg.defaultActionMode}
                    disabled={busy}
                    onChange={(e) => update(t.key, { defaultActionMode: e.target.value })}
                  >
                    {MODES.map((m) => <option key={m.key} value={m.key}>{m.label}</option>)}
                  </select>
                </div>
                <div className="sg-field">
                  <label className="sg-label">Strictness (0 – 3)</label>
                  <input
                    type="number" min={0} max={3}
                    className="sg-input"
                    value={cfg.strictness}
                    disabled={busy}
                    onChange={(e) => update(t.key, { strictness: parseInt(e.target.value, 10) || 0 })}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
